// import { Injectable } from '@angular/core';

// @Injectable({
//   providedIn: 'root'
// })
// export class ViewDetailsTrackerService {

//   private readonly maxClicksBeforeSignup = 3;
//   private readonly clickCountKey = 'viewDetailsClickCount';
//   private readonly isBlockedKey = 'isUserBlocked';
//   private readonly blockStartTimeKey = 'blockStartTime';
//   private readonly blockDuration = 24 * 60 * 60 * 1000; // 24 hours in milliseconds
//   private isBrowser: boolean;

//   constructor() {
//     this.isBrowser = typeof window !== 'undefined';
//     this.initializeClickCount();
//   }

//   private initializeClickCount(): void {
//     if (this.isBrowser) {
//       if (!this.getCookie(this.clickCountKey)) {
//         this.setCookie(this.clickCountKey, '0', 1);
//       }
//       if (!this.getCookie(this.isBlockedKey)) {
//         this.setCookie(this.isBlockedKey, 'false', 1);
//       }
//       if (!this.getCookie(this.blockStartTimeKey)) {
//         this.setCookie(this.blockStartTimeKey, '0', 1);
//       }
//     }
//   }

//   incrementClickCount(): void {
//     if (this.isBrowser) {
//       let count = this.getClickCount();
//       if (!this.isUserBlocked()) {
//         count++;
//         this.setCookie(this.clickCountKey, count.toString(), 1);
//         if (count >= this.maxClicksBeforeSignup) {
//           this.blockUser();
//         }
//       }
//     }
//   }

//   shouldPromptSignup(): boolean {
//     if (this.isBrowser && this.isUserBlocked()) {
//       const currentTime = Date.now();
//       const blockStartTime = this.getBlockStartTime();
//       if (currentTime - blockStartTime >= this.blockDuration) {
//         this.unblockUser();
//         return false;
//       }
//       return true;
//     }
//     return false;
//   }

//   resetClickCount(): void {
//     if (this.isBrowser) {
//       this.setCookie(this.clickCountKey, '0', 1);
//       this.unblockUser();
//     }
//   }

//   private getClickCount(): number {
//     if (this.isBrowser) {
//       return parseInt(this.getCookie(this.clickCountKey) || '0', 10);
//     }
//     return 0;
//   }

//   private blockUser(): void {
//     if (this.isBrowser) {
//       this.setCookie(this.isBlockedKey, 'true', 1);
//       this.setCookie(this.blockStartTimeKey, Date.now().toString(), 1);
//     }
//   }

//   private unblockUser(): void {
//     if (this.isBrowser) {
//       this.setCookie(this.isBlockedKey, 'false', 1);
//       this.setCookie(this.blockStartTimeKey, '0', 1);
//     }
//   }

//   private getBlockStartTime(): number {
//     if (this.isBrowser) {
//       return parseInt(this.getCookie(this.blockStartTimeKey) || '0', 10);
//     }
//     return 0;
//   }

//   isUserBlocked(): boolean {
//     if (this.isBrowser) {
//       return this.getCookie(this.isBlockedKey) === 'true';
//     }
//     return false;
//   }

//   private setCookie(name: string, value: string, days: number): void {
//     const expires = new Date(Date.now() + days * 86400000).toUTCString();
//     document.cookie = `${name}=${value}; expires=${expires}; path=/`;
//   }

//   private getCookie(name: string): string | null {
//     const matches = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
//     return matches ? decodeURIComponent(matches[1]) : null;
//   }

//   clearBlockingData(): void {
//     if (typeof window !== 'undefined') {
//       this.setCookie(this.clickCountKey, '', -1); // Remove the click count cookie
//       this.setCookie(this.isBlockedKey, '', -1);  // Remove the blocked status cookie
//       this.setCookie(this.blockStartTimeKey, '', -1); // Remove the block start time cookie
//     }
//   }
// }

//local stoarge code
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ViewDetailsTrackerService {

  private readonly maxClicksBeforeSignup = 3;
  private readonly clickCountKey = 'Count';
  private readonly isBlockedKey = 'isB';
  private readonly blockStartTimeKey = 'StartTime';
  // private readonly blockDuration = 30 * 1000; // 30 seconds in milliseconds
  private readonly blockDuration = 24 * 60 * 60 * 1000; // 24 hours in milliseconds
  private isBrowser: boolean;

  constructor() {
    this.isBrowser = typeof window !== 'undefined';
    this.initializeClickCount();
  }

  private initializeClickCount(): void {
    if (this.isBrowser) {
      if (!localStorage.getItem(this.clickCountKey)) {
        localStorage.setItem(this.clickCountKey, '0');
      }
      if (!localStorage.getItem(this.isBlockedKey)) {
        localStorage.setItem(this.isBlockedKey, 'false');
      }
      if (!localStorage.getItem(this.blockStartTimeKey)) {
        localStorage.setItem(this.blockStartTimeKey, '0');
      }
    }
  }

  incrementClickCount(): void {
    if (this.isBrowser) {
      let count = this.getClickCount();
      if (!this.isUserBlocked()) {
        count++;
        localStorage.setItem(this.clickCountKey, count.toString());
        if (count >= this.maxClicksBeforeSignup) {
          this.blockUser();
        }
      }
    }
  }

  shouldPromptSignup(): boolean {
    if (this.isBrowser && this.isUserBlocked()) {
      const currentTime = Date.now();
      const blockStartTime = this.getBlockStartTime();
      if (currentTime - blockStartTime >= this.blockDuration) {
        this.unblockUser();
        return false;
      }
      return true;
    }
    return false;
  }

  resetClickCount(): void {
    if (this.isBrowser) {
      localStorage.setItem(this.clickCountKey, '0');
      this.unblockUser();
    }
  }

  private getClickCount(): number {
    if (this.isBrowser) {
      return parseInt(localStorage.getItem(this.clickCountKey) || '0', 10);
    }
    return 0;
  }

  private blockUser(): void {
    if (this.isBrowser) {
      localStorage.setItem(this.isBlockedKey, 'true');
      localStorage.setItem(this.blockStartTimeKey, Date.now().toString());
    }
  }

  private unblockUser(): void {
    if (this.isBrowser) {
      localStorage.setItem(this.isBlockedKey, 'false');
      localStorage.setItem(this.blockStartTimeKey, '0');
    }
  }

  private getBlockStartTime(): number {
    if (this.isBrowser) {
      return parseInt(localStorage.getItem(this.blockStartTimeKey) || '0', 10);
    }
    return 0;
  }

  isUserBlocked(): boolean {
    if (this.isBrowser) {
      return localStorage.getItem(this.isBlockedKey) === 'true';
    }
    return false;
  }
}